var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBrandHortLightmono(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 168 43",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#C9CCCF",
    fillRule: "evenodd",
    d: "M0 21.48h39.116V1.86H0v19.62Z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F1",
    fillRule: "evenodd",
    d: "M0 34.518h29.337V21.48H0v13.038Z",
    clipRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#ABADB2",
    fillRule: "evenodd",
    d: "M0 21.48h19.619V1.86H0v19.62Z",
    clipRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E2E4",
    fillRule: "evenodd",
    d: "M0 41.098h19.619V21.48H0v19.618Z",
    clipRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9CCCF",
    fillRule: "evenodd",
    d: "M86.829 21.47V1.852h29.336c5.401 0 9.779 4.378 9.779 9.778v.062c0 5.4-4.378 9.779-9.779 9.778H86.829Z",
    clipRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F1",
    fillRule: "evenodd",
    d: "m126.189 41.073-19.741-19.588L86.83 41.073h39.359Z",
    clipRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#ABADB2",
    fillRule: "evenodd",
    d: "M86.829 21.486h19.619V1.867h-19.62v19.62Z",
    clipRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E2E4",
    fillRule: "evenodd",
    d: "M86.83 41.073h19.618V21.454H86.83v19.619Z",
    clipRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#ABADB2",
    fillRule: "evenodd",
    d: "M128.64 41.089V1.729l19.68 19.68-19.68 19.68Z",
    clipRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F1",
    fillRule: "evenodd",
    d: "M128.64 41.089H168V1.729l-39.36 39.36Z",
    clipRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#C9CCCF",
    fillRule: "evenodd",
    d: "M148.32 21.409 168 41.089h-39.36l19.68-19.68ZM78.107 6.27c8.36 8.36 8.36 21.913 0 30.272-8.359 8.36-21.912 8.36-30.272 0-8.359-8.36-8.359-21.913 0-30.272 8.36-8.36 21.913-8.36 30.272 0",
    clipRule: "evenodd"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F1",
    fillRule: "evenodd",
    d: "M41.516 21.395c0 11.836 9.595 21.43 21.43 21.43 11.836 0 21.431-9.594 21.431-21.43",
    clipRule: "evenodd"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#ABADB2",
    fillRule: "evenodd",
    d: "M62.996 21.43V0c-11.836 0-21.43 9.595-21.43 21.43h21.43Z",
    clipRule: "evenodd"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#E1E2E4",
    fillRule: "evenodd",
    d: "M62.996 21.395h-21.43c0 11.836 9.594 21.43 21.43 21.43v-21.43Z",
    clipRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBrandHortLightmono);
export default __webpack_public_path__ + "static/media/brand-hort-lightmono.00b05922.svg";
export { ForwardRef as ReactComponent };